import { render } from "./CreateAcquiringView.vue?vue&type=template&id=795709b8"
import script from "./CreateAcquiringView.vue?vue&type=script&lang=js"
export * from "./CreateAcquiringView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__